import Link from 'next/link'
import React, { ReactNode } from 'react'
import useBreakpoints from '../../hooks/useBreakpoints'

type StyledLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>

export const StyledLink = ({ className, ...rest }: StyledLinkProps) => (
  <a className={`no-underline ${className ?? ''}`.trim()} {...rest} />
)

type ICardLink = {
  urlRoute: string
  children?: ReactNode
  onClick?: () => void
}

const CardLocationLink = ({ urlRoute, children, onClick }: ICardLink) => {
  const { isUpMd } = useBreakpoints()

  if (isUpMd) {
    return (
      <StyledLink href={urlRoute ?? ''} target="_blank" rel="noreferrer">
        {children}
      </StyledLink>
    )
  }

  if (onClick) {
    return (
      <a
        href={urlRoute ?? ''}
        onClick={(e) => {
          e.preventDefault()
          onClick()
        }}
      >
        {children}
      </a>
    )
  }

  return (
    <Link href={urlRoute ?? ''} passHref>
      {children}
    </Link>
  )
}

export default CardLocationLink
